<template>
  <div :class="{ preloader_active: !ready }">
    <!-- Header -->
    <TheHeader />

    <!-- Main content -->
    <nuxt :key="$route.path" />

    <!-- Footer -->
    <TheFooter />

    <transition>
      <div v-if="!ready" class="overlay-preloader"><BasePreloader /></div>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { CommonMixin } from '~/mixins/Common'
import { FixBody } from '~/mixins/FixBody.js'
import objectFitImages from 'object-fit-images'
import TheHeader from '~/components/TheHeader/TheHeader'
import TheFooter from '~/components/TheFooter/TheFooter'

export default {
  mixins: [CommonMixin, FixBody],
  components: { TheHeader, TheFooter },
  data() {
    return {
      ready: false
    }
  },
  methods: {
    ...mapActions({
      checkToken: 'auth/checkToken',
      createUser: 'auth/createUser'
    }),
    async changeFavicon() {
        let faviconElement = null
        const { data } = await this.$axios.get('/header')
        const { favicon } = data
        if(favicon) {
        const nodeList = document.getElementsByTagName("link");
        for (let i = 0; i < nodeList.length; i++) {
            if((nodeList[i].getAttribute("rel") == "icon")||(nodeList[i].getAttribute("rel") == "shortcut icon"))
            {
                faviconElement = nodeList[i]
            }
        }
        faviconElement.href = favicon;
        }
    }
  },
  async created() {
    try {
      await this.$store.dispatch('data/getHomePageData');
      this.$store.commit('data/setWindowWidth');
      window.addEventListener('resize', () => this.$store.commit('data/setWindowWidth'));
    } catch (e) { }
  },
  mounted() {
    if (!process.browser) return

    this.fixBody()
    this.iosCursore()
    this.isSafary()
    this.isIE()
    this.detectMouse()
    this.changeFavicon()
    objectFitImages()

    if (this.$store.state.auth.token) {
      if (this.$store.state.auth.loggedIn) {
        this.ready = true
        this.unfixBody()
      } else {
        this.ready = true
        this.unfixBody()
      }
    } else {
      this.ready = true
      this.unfixBody()
    }

    this.$store.commit('common/TOGGLE_PRELOADER', false)
  }
}
</script>

<style lang="scss" scoped>
.preloader_active {
  position: fixed;
  height: 100vh;
  width: 100%;
  overflow: hidden !important;
}
.overlay-preloader {
  position: fixed;
  z-index: 100;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: hsla(0, 0%, 77.17%, 0.85);
}
</style>



// WEBPACK FOOTER //
// layouts/default.vue